'use client'

import { BsCheckCircle } from 'react-icons/bs'
import { useTranslation } from 'react-i18next'
import Link from 'next/link'

const PopUp = ({ onClose }) => {
  const { t } = useTranslation()

  return (
    <section
      className="container mx-auto my-6 px-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="signup-title"
    >
      <div className="mx-auto max-w-md rounded-2xl p-6 sm:p-8 ">
        {/* A dialog label, not the page heading. As an <h1> this put a SECOND top-level heading
            into the hydrated DOM of every page on the site (the SSR HTML has one, then this
            mounts client-side). `aria-labelledby` on the dialog is what names it for assistive
            tech — the heading level is free to be correct. Tailwind preflight resets heading
            size/weight to inherit and the size comes from the utility classes, so this renders
            identically. */}
        <h2
          id="signup-title"
          className="text-center text-2xl md:text-3xl font-extrabold text-white tracking-tight text-balance"
        >
          {t('createNsfwAiContent')}
        </h2>
        <p className="mt-2 text-center text-base md:text-lg font-semibold text-orange-300 text-balance">
          {t('joinFreeIn15Seconds')}
        </p>

        {/* ========= ICON BUTTON (compact) ========= */}
        <div className="mt-6 flex justify-center">
          <Link
            href="/signup"
            onClick={() => onClose?.()}
            className={`
      inline-flex items-center justify-center gap-2
      px-6 py-3 sm:px-8 sm:py-4
      rounded-full
      bg-[var(--main-bg-color)] text-white text-lg sm:text-xl font-semibold
      shadow-lg ring-1 ring-white/10
      transition-transform duration-200 ease-out
      hover:scale-105 active:scale-95 hover:ring-white/30 hover:shadow-xl
      focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60
      focus-visible:ring-offset-2 focus-visible:ring-offset-slate-900
      motion-reduce:transform-none
    `}
          >
            <span className="text-lg">{t('signUp')}</span>
            <span
              aria-hidden="true"
              className="text-2xl font-bold leading-none"
            >
              →
            </span>
          </Link>
        </div>

        {/* ========= /ICON BUTTON ========= */}

        {/* Benefits */}
        <div className="mt-8">
          <div className="relative overflow-hidden rounded-xl p-5 bg-white/5 ring-1 ring-white/10 backdrop-blur-md">
            {/* Background image (decorative) */}
            <div
              aria-hidden="true"
              className="
                absolute inset-0 -z-20
                bg-[url('/assets/nsfw-ai-generator-girl.jpg')]
                bg-cover bg-center
              "
            />
            {/* Overlay for readability */}
            <div
              aria-hidden="true"
              className="absolute inset-0 -z-10 bg-black/80"
            />

            <h2 className="relative text-center text-sm font-semibold text-white/90 tracking-wide">
              {t('whatYoullInstantlyUnlock')}
            </h2>

            <ul className="relative mt-4 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3 w-fit mx-auto">
              {[
                t('freeAiGirlfriendChat'),
                t('createAiImagesNoFilter'),
                t('starterCreditsIncluded'),
                t('noCreditCardRequired'),
              ].map((item) => (
                <li key={item} className="flex items-center gap-2">
                  <BsCheckCircle
                    aria-hidden="true"
                    className="shrink-0 text-orange-300"
                    size={18}
                  />
                  <span className="text-sm font-semibold text-gray-100">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}

export default PopUp
